import Email from '../../component/inputs/email/index'
import Password from '../../component/inputs/password/index'
import Checkbox from '../../component/inputs/checkbox/index'
import FacebookButton from '../../component/buttons/facebook/index'
import GoogleButton from '../../component/buttons/google/index'
import Button from '../../component/buttons/button/index'
import Header from '../../component/header/index'
import axios from 'axios'
import '../../../icons'
import Close from '../../component/close/index'

export default {
  name: 'Login',
  inject: ['$validator'],
  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      isLoading: false,
      serverValidationError: false,
      serverValidationErrorMessage: '',
      lang: this.$route.params.lang
    }
  },
  components: {
    'kw-email': Email,
    'kw-password': Password,
    'kw-checkbox': Checkbox,
    'kw-facebook': FacebookButton,
    'kw-google': GoogleButton,
    'kw-button': Button,
    // eslint-disable-next-line no-undef
    'kw-header': Header,
    'kw-close' : Close
  },
  computed: {
    isFormValid () {
      if (this.errors.items.length !== 0 || this.form.email === '' || this.form.password === '') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    validateAndSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isLoading = true

          axios.post(`${process.env.API_URL}/user/login`, this.form, {
            withCredentials: 'true',
            credentials: 'same-origin'
          })
            .then(({ data }) => {
              let accessToken = data.token

              if (!data.valid) {
                this.serverValidationErrorMessage = data.message
                this.serverValidationError = true
                this.isLoading = false

                return
              }

              this.isLoading = false
              this.setTokenAndRedirect(accessToken)
            })

            .catch(error => {
              this.serverValidationErrorMessage = error
              this.isLoading = false
            })
        }
      })
    },

    decodeToken (token) {
      let base64Url = token.split('.')[1]
      let base64 = base64Url.replace('-', '+').replace('_', '/')
      return JSON.parse(window.atob(base64))
    },

    setTokenAndRedirect (accessToken) {
      let url
      let payload = this.decodeToken(accessToken)
      let expirationTime = new Date(payload.exp * 1000)

      window.$cookies.set('access_token', accessToken, expirationTime, '/')

      if (payload.aud === 'admin') {
        url = `${process.env.BACKOFFICE_AREA_URL}` /// ${this.lang}/
      }

      if (payload.aud === 'user') {
        url = `/${this.lang}${process.env.PERSONAL_AREA_URL}`
      }

      if (payload.aud === 'partner') {
        url = `/${this.lang}${process.env.PARTNERS_PLATFORM_URL}`
      }

      window.location.replace(url)
    },

    removeMessage () {
      this.serverValidationError = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/views/login/login.js